import React, { useState } from "react";
import { Search, Award, Target, TrendingUp } from "react-feather";
import "./LeaderDashboardTable.css";

const formatNumber = (num) => num?.toLocaleString("en-US") || "0";
const formatMillions = (num) => (num ? (num / 1_000_000).toFixed(1) + "M" : "0M");

const COLORS = {
  MDRT: "#3B82F6",
  COT: "#F59E0B",
  TOT: "#8B5CF6"
};

const LIGHT_COLORS = {
  MDRT: "rgba(59, 130, 246, 0.1)",
  COT: "rgba(245, 158, 11, 0.1)",
  TOT: "rgba(139, 92, 246, 0.1)"
};

const cardIcons = {
  MDRT: <Award />,
  COT: <Target />,
  TOT: <TrendingUp />
};

const StatusBadge = ({ value, type }) => {
  // CASE 1: already marked as qualified
  if (value === "qualified") {
    return (
      <span
        className="leaderDashboard-badge"
        style={{
          color: "green",
          fontWeight: "bold"
        }}
      >
        {React.cloneElement(cardIcons[type], { size: 14 })}
        Qualified
      </span>
    );
  }

  if (typeof value === "object" && value?.gap !== undefined) {
    //If gap is ZERO → treat as qualified
    if (value.gap === 0) {
      return (
        <span
          className="leaderDashboard-badge"
          style={{
            backgroundColor: "rgba(34, 197, 94, 0.12)",
            color: "green",
            fontWeight: "bold"
          }}
        >
          Qualified
        </span>
      );
    }

    return (
      <span
        className="leaderDashboard-badge"
        style={{
          backgroundColor: "transparent",
          border: "none",
          color: "#374151"
        }}
      >
        Gap: {formatMillions(value.gap)}
      </span>
    );
  }

  return null;
};

const LeaderDashboardTable = ({ agent_performance_ranking = [] }) => {
  const [inputValue, setInputValue] = useState("");
  const [search, setSearch] = useState(null); // null = show all

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const value = inputValue.trim().toLowerCase();

      console.log("ENTER VALUE:", value);

      setSearch(value === "" ? null : value);
    }
  };

  const filtered = (
    search
      ? agent_performance_ranking.filter((a) => {
        return (
          a.agent_name?.toLowerCase().includes(search) ||
          a.agent_code?.toLowerCase().includes(search) ||
          a.branch?.toLowerCase().includes(search)
        );
      })
      : agent_performance_ranking
  )
    .slice()
    .sort((a, b) => (b.fyp || 0) - (a.fyp || 0));

  return (
    <div className="leaderDashboard-tableContainer">
      <div className="leaderDashboard-tableHeader">
        <div>
          <h2>Agent Performance Ranking</h2>
          <h4 className="leaderDashboard-h4">
            Track qualifications and remaining gaps per tier
          </h4>
        </div>

        <div className="leaderDashboard-actions">
          <div className="leaderDashboard-search">
            <Search size={14} />
            <input
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Search agents..."
            />
          </div>
        </div>
      </div>

      <table className="leaderDashboard-table">
        <thead>
          <tr>
            <th>No</th>
            <th>Agent</th>
            <th>FYP (LKR)</th>
            <th>MDRT</th>
            <th>COT</th>
            <th>TOT</th>
          </tr>
        </thead>

        <tbody>
          {filtered.map((agent, index) => (
            <tr key={index}>
              <td className="leaderDashboard-rank">{index + 1}</td>

              <td>
                <div className="leaderDashboard-agentName">{agent.agent_name}</div>
                <div className="leaderDashboard-agentSub">{agent.agent_code} • {agent.branch}</div>
              </td>

              <td className="leaderDashboard-fyp">{formatNumber(agent.fyp)}</td>

              <td><StatusBadge value={agent.mdrt} type="MDRT" /></td>
              <td><StatusBadge value={agent.cot} type="COT" /></td>
              <td><StatusBadge value={agent.tot} type="TOT" /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LeaderDashboardTable;